module.exports = __webpack_public_path__ + "img/北京冷库 (2).c3645750.jpg";